export default {
  credit_expert: 'credit_expert',
  identity: 'identity',
  basic: 'basic',
  breach: 'breach',
  breachPlus: 'breach_plus',
};
